
<template>
  <div>
      <!-- <mheader></mheader> -->
      <div style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">       
              <!-- 表单内容 -->
         <div v-show="showVue" class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 font mb-3">
                <!-- <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/> -->
                <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   我经销的品种
                </span>
                 <span class="ml-5">
                          <span>
                              显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>页,
                          </span>
                          <span>
                              总共<span class="record">{{Record}}</span>条数据
                          </span> 
                   </span>
                
                <span class="float-right span_close mr-1" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
              
             <!-- <p class="query mb-2 mt-2"><span  style="font-weight:600;">库存详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span></p> -->
                   <div class="row ml-2 mb-2">
                     <div class="col-lg-9">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                    <input type="text" class="form-control font heit" v-model="searchForm.ypmc" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                        
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产地名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                               
                                  </div>   
                               </div>  
                                <div class="col-lg-3">
                                      <div class="row ml-lg-3">            
                                            <button class="bg-primary button_zi heit" @click="getClerkGetImgList()">查询</button>
                                  </div>
                                 </div>  
                                 </div>
                                   
                             </div>
                               
                          </div>
                       </div>
                </div>    
          <div v-if="showPage">
            <table class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;">
                       <th>代理商</th>
                        <th>药品名称</th>
                        <th>产地名称</th>
                        <th>规格</th>
                        <th>包装</th>
                        <th>单位</th>
                        <th>未审核图片</th>
                        <th>未通过图片</th>
                        <th>已通过图片</th>
                        <th>已上传图片</th>
                        <th>上传图片</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index">
                              <td class="jz_middle">{{item.qty}}</td>
                              <td class="jz_middle" @dblclick="onInputdrugName(index)">{{item.ypmc}}</td>
                              <td class="jz_middle" @dblclick="onInputcustomerName(index)">{{item.cdmc}}</td>
                              <td class="jz_middle">{{item.gg}}</td>
                              <td class="jz_middle">{{item.bz}}</td>
                              <td class="jz_middle">{{item.dw}}</td>
                              <td class="jz_middle">{{item.wsh}}</td>
                              <td class="jz_middle">{{item.wtg}}</td>
                              <td class="jz_middle">{{item.ytg}}</td>
                              <td class="jz_middle">{{item.alL_PIC}}</td>
                              <td class="jz_middle">
                                  <router-link :to="{path:'/uploadPictures',query:{ypbh:item.ypbh}}">
                                       <button class="btn btn-primary" style="font-size:10px;">
                                            上传图片
                                       </button>
                                  </router-link>
                              </td>
                      </tr>
                    </tbody>
                  </table>
                   <div>
                       <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                  </div>
                
                    <p class="text-center">
                        <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                      </p>
                 </div>
                   <div v-else>

                       <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>
                    

  </div> 
       <!-- container -->   
      </div>
  
                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../components/Pagination.vue"
import Loading from '../components/Loading.vue'
import { async } from 'q';
export default {
      name: 'Endregion',
    data () {
      return {
         Height:0,
        searchForm: {
          ypmc: '',
          cdmc: '',
          gg: '',
        },//搜索内容
        searchData:[],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'0',//总页数
        PageNo:1, //当前页码

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

              showPage:true,

              showVue:false,
        
        totalMoney:'',
      }
    },
    components:{
    
        vPagination,
        Loading
    },
    computed:{
         
},


methods: {

     pagechange:function(currentPage){
        
           this. getClerkGetImgList(currentPage);
         
     },

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
      

      onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.ypmc=this.searchData[index].ypmc;
          }
          else {
            this.searchForm.ypmc=this.tableData[index].ypmc;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.cdmc=this.searchData[index].cdmc;
          }
          else
          {
            this.searchForm.cdmc=this.tableData[index].cdmc;
          }  
      },
      getClerkGetImgList: async function (PageIndex) {
        const that = this
        const { data: res } = await that.$http.post('Dls/getFun', {
          action: 'ClerkGetImgList',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            ypmc: that.searchForm.ypmc.trim(),
            cdmc: that.searchForm.cdmc.trim(),
            gg: that.searchForm.gg.trim()
          })
        })
        // console.log(res)
           if(res.isok){
                 if(res.data.isok){
                     const obj=res.data
                      that.showVue=true;
                      that.tableData = obj.rows
                      that.Pcount = obj.pcount
                      that.Record = obj.record
                       that.total = obj.record
                      that.totalMoney=obj.totalMoney
                       if(this.tableData.length>0)
                          {
                              this.showPage=true;
                          }
                          else{
                              this.showPage =false;
                          }
                 }
                 else{
                   alert(res.data.msg);
                 }
           }
           else{
             alert(res.message);
           }
         
         
      },

      //搜索功能
     // 打印
    start_print(){
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
    }

    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
     created () {
        this.getClerkGetImgList();
        
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.jz_middle{
   vertical-align:middle;
 }
 .record{
      color:green;
      font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Endregion.vue